import { chain, startsWith } from 'lodash';
import { routes } from '../lib';

export default chain(routes).values().filter((route) => (
  typeof route == 'string'
)).map((route) => (
  route.split('/')[1]
)).reject((route) => (
  startsWith(route, ':')
)).compact().uniq().value();